import React, { useState } from 'react';
import { useConfirmGuestInfoMutation } from '../../../../store/reservations/reservationsApi';
import { IToast } from '../../../../interfaces/components/IToast';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import Toast from '../../../../shared/toast';


interface IGuestInfoModal {
    openModal: boolean;
    data: any;
    reservationId?: string;
    handleCloseModal: () => void;
}

const GuestInfoModal = ({
    openModal,
    data,
    reservationId,
    handleCloseModal,
}: IGuestInfoModal) => {
    const [allData, setAllData] = useState<any>(data)
    const [showToast, setShowToast] = useState<IToast | null>();
    const [confirmGuestInfo, { isLoading: isLoadingGuestInfo }] = useConfirmGuestInfoMutation();

    const escapeHtmlString = (htmlString: any) => {
        return htmlString
            .replace(/"/g, '\\"')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r');
    };

    const onFormatHtml = (text: string) => {
        let htmlText: any
        try {
            htmlText = escapeHtmlString(text);
            htmlText = JSON.parse(`"${htmlText}"`);
        } catch (error) {
            console.error('Error processing HTML string:', error);
        }
        htmlText = htmlText?.replace(/\n/g, '');
        return htmlText
    }

    const onCloseModal = () => {
        handleCloseModal();
    }

    const onClickConfirmGuest = async (id: string) => {
        if (reservationId) {
            try {
                const formData = {
                    reservationId: reservationId,
                    guestProfileId: id
                }
                await confirmGuestInfo(formData).unwrap();
                const formatAllData = (allData && allData?.length > 0) && allData?.find((item: any) => item?.id === id)
                setAllData([formatAllData])
            } catch (err) {
                setShowToast({ type: 'error', message: 'Something went wrong!' })
            }
        }
    }

    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Guest Personal Info'
            contentContainerStyle='!min-w-[70vw]'>
            <div className={'p-2 min-w-[65vw] min-h-[300px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Guest Info</p>
                </div>
                {allData ?
                    <>
                        {(Array.isArray(allData) ? allData : [allData])?.map((item: any, index: number) => {
                            return (
                                <div className='bg-[#E8F1FD] rounded-[6px] p-3 mb-6'>
                                    {(Array.isArray(allData) && allData?.length > 1 && reservationId) &&
                                        <div className='flex flex-row justify-end mb-2'>
                                            <Button
                                                label={'Confirm Guest'}
                                                className='btn-primary !rounded-xl mt-2 min-w-[150px]'
                                                onClickButton={() => onClickConfirmGuest(item?.id)}
                                            />
                                        </div>
                                    }
                                    <div
                                        dangerouslySetInnerHTML={{ __html: `${onFormatHtml(Array.isArray(allData) ? item?.htmlContent : item)}` || "" }}
                                        className="pb-10 px-10 py-3 min-h-72 overflow-auto profile"
                                    ></div>
                                </div>
                            )
                        })}
                    </>
                    : <div className='bg-[#E8F1FD] rounded-[6px] p-3 flex flex-row justify-center items'>
                        <p className='text-primary-light my-10 text-center'>No details found for this Guest</p>
                    </div>
                }
                <div className='flex flex-row justify-center my-5'>
                    <Button
                        label={'Close Modal'}
                        className='btn-primary-rounded-less min-w-[140px]'
                        onClickButton={onCloseModal}
                    />
                </div>
                {showToast?.message &&
                    <Toast
                        type={showToast?.type}
                        text={showToast?.message}
                        onHandleCloseToast={() => setShowToast(null)}
                    />
                }
            </div>
        </Modal >
    )
}
export default GuestInfoModal;
